import authStore from './authStore';
import deliveryStore from './deliveryStore';
import furnituresStore from './furnituresStore';
import loadingStore from './loadingStore';
import projectStore from './projectStore';
import serviceOfferStore from './serviceOfferStore';
import dimensionStore from './dimensionStore';
import adviceStore from './adviceStore';
import routeStore from './routeStore';
import validateStore from './validateStore';

export default {
  routeStore,
  adviceStore,
  dimensionStore,
  authStore,
  deliveryStore,
  loadingStore,
  furnituresStore,
  projectStore,
  serviceOfferStore,
  validateStore,
};
